import { Stack } from '@mui/material';
import { useState } from 'react';

import { Button, Input, Modal, Separator } from '@/design-system';
import { useGlobalModal } from '@/global-hooks/use-global-modal';
import { formatWithoutFraction } from '@/utils/numbers/formatters';

export type CustomRangeProps = {
  setCustomRange: (_s: string) => void;
};

export const CustomRangeModal = () => {
  const { handleClose, open, props } = useGlobalModal('CUSTOM_RANGE_MODAL');
  const [minValue, setMinValue] = useState<string>('');
  const [maxValue, setMaxValue] = useState<string>('');

  const isInputsFilled = !!minValue && !!maxValue;

  const handleNumberChange = (value: string, setter: (_v: string) => void) => {
    if (/^-?\d*$/.test(value)) {
      setter(value);
    }
  };

  const handleApply = () => {
    if (isInputsFilled) {
      props?.setCustomRange(
        `${formatWithoutFraction(minValue)} - ${formatWithoutFraction(maxValue)}`,
      );
      handleClose();
      setMinValue('');
      setMaxValue('');
    }
  };

  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        if (!next) handleClose();
      }}
      title="Custom Range"
      showClose
      maxWidth={516}
    >
      <Stack flexDirection="column" gap="24px">
        <Separator tone="subtle" />
        <Stack gap="16px" width="100%">
          <Input
            size="lg"
            label="Min"
            placeholder="Enter min range"
            value={minValue}
            onChange={(e) => handleNumberChange(e.target.value, setMinValue)}
          />
          <Input
            size="lg"
            label="Max"
            placeholder="Enter max range"
            value={maxValue}
            onChange={(e) => handleNumberChange(e.target.value, setMaxValue)}
          />
        </Stack>

        <Button size="lg" onClick={handleApply} disabled={!isInputsFilled}>
          Apply
        </Button>
      </Stack>
    </Modal>
  );
};
